import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1 5.9a2 2 0 011.268-1.86l7-2.752a2 2 0 011.464 0l7 2.751A2 2 0 0119 5.901v9.628c0 2.69-1.433 5.17-3.747 6.485l-4.357 2.476a1.812 1.812 0 01-1.792 0l-4.357-2.476C2.433 20.699 1 18.218 1 15.529V5.9z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);